import { Navigate, useLocation } from 'react-router-dom';

import { useAuthQuery } from '../auth/hooks/useAuthQuery';
import UnauthorizedPage from '../auth/pages/Unauthorized';
import { useAbility } from '../contexts/AbilityContext';
import NotFound from '../shared/pages/NotFound';

function CustomRoute({ children, allowedAction, allowedSubject }): JSX.Element {
  const { user } = useAuthQuery();
  const location = useLocation();
  const ability = useAbility();

  if (!user && !location.state?.logout) {
    return <Navigate to="/login" replace state={{ path: `${location.pathname}${location.search}` }} />;
  }

  if (ability.cannot(allowedAction, allowedSubject)) {
    return <UnauthorizedPage />;
  }

  if (location?.state && location.state.notFound) {
    return <NotFound />;
  }

  return children;
}

export default CustomRoute;
